<p-confirmDialog key="confirm" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="table" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="row" style="padding: 5px">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<!--Menu Bar-->
				<div style="background-color: #ffffff">
					<div class="range-body">
						<div class="DateBodyDiv">
							<label>Date Between:</label>
							<p-calendar
								showIcon="true"
								showButtonBar="true"
								[(ngModel)]="StartDate"
								(ngModelChange)="onStartDateChange($event)"
								name="StartDate"
							></p-calendar>
							<label class="MarginLeft">and</label>
							<p-calendar
								showIcon="true"
								showButtonBar="true"
								[(ngModel)]="EndDate"
								(ngModelChange)="onEndDateChange($event)"
								name="EndDate"
							></p-calendar>

							<!-- <label>Time Between:</label>
                            <p-calendar showTime="true" timeOnly="true" hourFormat="12" showIcon=true showButtonBar="true"  [(ngModel)]="StartTime" name="StartTime" (ngModelChange)="onStartTimeChange($event)"></p-calendar>
                            <label>and</label>
                            <p-calendar showTime="true" timeOnly="true" hourFormat="12" showIcon=true showButtonBar="true"  [(ngModel)]="EndTime" name="EndTime" (ngModelChange)="onEndTimeChange($event)"></p-calendar> -->
						</div>

						<!-- <div class="WrapDiv">

                            <label>Wrap Mode:</label>

                            <div class="WrapOptionDiv">
                                
                                <div class="WrapSingleOption">
                                    <img src="assets/images/StudentsWithAlertsWrapTime.png" class="WrapImg" (click)="onWrapTime()">
                                    <input type="radio" class="form-control CHK CenterRadio" id="Wrap" [value]="true" [(ngModel)]="WrapTime" name="WrapTime">
                                </div>

                                <div class="WrapSingleOption">
                                    <img src="assets/images/StudentsWithAlertsNoWrap.png" class="WrapImg" (click)="onNoWrapTime()">
                                    <input type="radio" class="form-control CHK CenterRadio" id="NoWrap" [value]="false" [(ngModel)]="WrapTime" name="WrapTime">
                                </div>

                            </div>

                        </div> -->
					</div>

					<!--Buttons-->
					<div class="button-body flex">
						<button [disabled]="MainLoading == true || loading == true" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">
							Refresh
						</button>

						<!--INSERT CUSTOM BUTTONS HERE-->
						<button
							[disabled]="SelectedIncidents.length == 0 || MainLoading == true || loading == true"
							class="btn btn-primary"
							style="margin-left: 5px"
							(click)="onRemoveAlert()"
						>
							Deactivate Alert
						</button>
						<!-- <button [disabled]="MainLoading ==true || loading == true" class="btn btn-primary" style="margin-left:5px;" (click)="onMergeToGroup()">Merge To Group</button> -->

						<button
							*ngIf="IsSU() == true"
							[disabled]="SelectedIncidents.length == 0 || MainLoading == true || loading == true"
							class="btn btn-danger"
							style="margin-left: 5px"
							(click)="onDeleteIncidents()"
						>
							Delete Incident (SU Only)
						</button>
					</div>
				</div>

				<!--Table-->
				<div class="table-main-body">
					<p-table
						#mydt
						[value]="lstIncidents"
						[loading]="MainLoading == true || loading == true"
						[paginator]="true"
						[(rows)]="pagerows"
						[(first)]="pagefirst"
						[showCurrentPageReport]="true"
						[resizableColumns]="false"
						sortMode="multiple"
						styleClass="p-datatable-striped"
						selectionMode="multiple"
						[(selection)]="SelectedIncidents"
						dataKey="IncidentID"
						(onFilter)="onHandleFilter($event)"
						(onSort)="onHandleSort($event)"
						(onRowSelect)="onRowSelect($event)"
						(onRowUnselect)="onRowUnselect($event)"
						currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
						[rowsPerPageOptions]="[5, 10, 25, 50]"
					>
						<!--Headers-->
						<ng-template pTemplate="header">
							<!--Filter or Select from Dropdown-->
							<tr>
								<th></th>
								<!--Selected-->

								<!--INSERT CUSTOM FILTERS HERE-->

								<!--AlertDesc-->
								<!-- <th>
                                    <p-columnFilter field="AlertDesc" matchMode="equals" [showMenu]="false">
                                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                            <p-dropdown #filterAlertDesc [ngModel]="value" [options]="lstAlertDesc" (onChange)="filter($event.value)"
                                                placeholder="Any" [showClear]="true">
                                                <ng-template let-value pTemplate="item">
                                                    <span>{{value}}</span>
                                                </ng-template>
                                            </p-dropdown>
                                        </ng-template>
                                    </p-columnFilter>
                                </th> -->

								<!--StudentName-->
								<th>
									<p-columnFilter type="text" field="StudentName" matchMode="contains" [showMenu]="true"></p-columnFilter>
								</th>

								<!--SchoolName-->
								<th>
									<p-columnFilter field="SchoolName" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterSchoolName
												[ngModel]="value"
												[options]="lstSchoolName"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--IncidentDTDesc-->
								<th>
									<!-- <p-columnFilter type="date" field="IncidentDT" matchMode="DATE_AFTER" [showMenu]="true"></p-columnFilter> -->
									<!-- <p-columnFilter type="text" field="IncidentDTDesc" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
								</th>

								<!--InfractionDesc-->
								<th>
									<p-columnFilter field="InfractionDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterInfractionDesc
												[ngModel]="value"
												[options]="lstInfractionDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--PenaltyDesc-->
								<th>
									<p-columnFilter field="PenaltyDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterPenaltyDesc
												[ngModel]="value"
												[options]="lstPenaltyDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--ActiveDesc-->
								<th>
									<p-columnFilter field="ActiveDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterActiveDesc
												[ngModel]="value"
												[options]="lstActiveDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--PartOfGroupDesc-->
								<th>
									<p-columnFilter field="PartOfGroupDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterPartOfGroupDesc
												[ngModel]="value"
												[options]="lstPartOfGroupDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--GroupName-->
								<th>
									<p-columnFilter type="text" field="GroupName" matchMode="contains" [showMenu]="true"></p-columnFilter>
								</th>

								<!--ContinueAlertDesc-->
								<th class="CheckColumn">
									<p-columnFilter field="ContinueAlertDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterContinueAlertDesc
												[ngModel]="value"
												[options]="lstContinueAlertDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>
							</tr>

							<!--Column Names-->
							<tr style="height: 4rem">
								<th>
									<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
								</th>

								<!--INSERT CUSTOM COLUMNS HERE-->
								<!-- <th pSortableColumn="AlertDesc">Alert<p-sortIcon field="AlertDesc"></p-sortIcon></th> -->
								<th pSortableColumn="StudentName">Student<p-sortIcon field="StudentName"></p-sortIcon></th>
								<th pSortableColumn="SchoolName">School (Where Incident Occurred)<p-sortIcon field="SchoolName"></p-sortIcon></th>
								<th pSortableColumn="IncidentDT">Date/Time<p-sortIcon field="IncidentDT"></p-sortIcon></th>
								<th pSortableColumn="InfractionDesc">Infraction<p-sortIcon field="InfractionDesc"></p-sortIcon></th>
								<th pSortableColumn="PenaltyDesc">Action<p-sortIcon field="PenaltyDesc"></p-sortIcon></th>
								<th pSortableColumn="ActiveDesc">Student Active<p-sortIcon field="ActiveDesc"></p-sortIcon></th>
								<th pSortableColumn="PartOfGroupDesc">Part of Group Action<p-sortIcon field="PartOfGroupDesc"></p-sortIcon></th>
								<th pSortableColumn="GroupName">Group<p-sortIcon field="GroupName"></p-sortIcon></th>
								<th class="CheckColumn" pSortableColumn="ContinueAlert">Alert On<p-sortIcon field="ContinueAlert"></p-sortIcon></th>
							</tr>
						</ng-template>

						<!--Data-->
						<ng-template pTemplate="body" let-Incident>
							<tr [pSelectableRow]="Incident">
								<td>
									<p-tableCheckbox [value]="Incident"></p-tableCheckbox>
								</td>
								<td *ngFor="let col of cols" style="font-weight: bold">
									{{ Incident[col.field] }}
								</td>

								<td class="CheckColumn">
									<i *ngIf="Incident.ContinueAlert == 1" class="fa fa-check-square IconFont SuccessColor" aria-hidden="true"></i>
									<i *ngIf="Incident.ContinueAlert == 0" class="fa fa-times-circle IconFont ErrorColor" aria-hidden="true"></i>
								</td>
							</tr>
						</ng-template>
					</p-table>
				</div>

				<!--Error Message-->
				<div class="TopMargin">
					<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
						{{ errorMessage }}
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
